import { useTranslate } from '@va/localization';
import { useEffect, useState } from 'react';

export function useFormError() {
  const translate = useTranslate();
  const [formError, setFormError] = useState<string>('');

  useEffect(() => {
    if (formError) {
      const timer = setTimeout(() => setFormError(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [formError]);

  const handleFormError = (message: string) => {
    setFormError(translate(message));
  };

  return {
    formError,
    handleFormError,
  };
}
